import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const NotificationContext = createContext(null);

export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const [counts, setCounts] = useState({ messages: 0, likes: 0, visits: 0 });
  const timer = useRef(null);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/notifications/counts");
      setCounts(data);
    } catch (e) {}
  }, [user]);

  const markSeen = useCallback(async (kind) => {
    setCounts((c) => ({ ...c, [kind]: 0 }));
    try {
      await api.post(`/notifications/seen/${kind}`);
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (!user) {
      setCounts({ messages: 0, likes: 0, visits: 0 });
      return;
    }
    refresh();
    timer.current = setInterval(refresh, 15000);
    return () => clearInterval(timer.current);
  }, [user, refresh]);

  return (
    <NotificationContext.Provider value={{ counts, refresh, markSeen }}>
      {children}
    </NotificationContext.Provider>
  );
};
